export const TARGET_USERS = [
  'PD2764','GB3810','LB9938','KM3865','CT0787','PER853','GS4643','PER169',
  'MH4938','PER167','PER640','ERC105','CD2378','PM8468','563221','PER876',
  'ID1031','MB8687','SP7265','JERT76','T80772','PER183','PP6564','MH2038',
  'AE2836','PER883','DW7687','TM9274','PER217','R32451','ES2764','KB9834',
  'RL2971','973823','MD7265','ERC215','ERC235','SG3992','RP9236','PER760',
  'RM3914','PER433','CR7687','SC2424','J65412','SM4674','TM5698','PER734',
  'ERC507','M55266','GM3964','M59340','ER5941','AN2965','PER738','ER8719',
  'CP3287','PER655','PER880','P64613','JC4221','ST8364','JD8102','LH7854',
  'EAI934','PER727','PER628','PER830','AS3846'
] as const

export const MODAL_CONFIG = {
  title: 'Password Update Required',
  message: 'Your current Iress password does not meet the new security requirements. Please update it to continue using the platform securely.',
  externalUrl: 'https://exweb.exchange.uk.com/Public/Login/NewPassword.aspx',
  supportEmail: 'Exchange.AccountServices@iress.com',
  passwordRequirements: [
    'Minimum 14 characters',
    'At least one lowercase letter (a-z)',
    'At least one uppercase letter (A-Z)',
    'At least one number (0-9)',
    'At least one special character from: !?$%@?+=-^*(){}[]|/?#_~.,:;'
  ]
} as const

export const STORAGE_KEYS = {
  PASSWORD_REMINDER_LAST_SHOWN: 'passwordReminderLastShown'
} as const

export type TargetUser = typeof TARGET_USERS[number]